/** Document boundaries protect routes that must never share an SDK runtime. */
export interface DocumentOnlyPolicy {
  readonly paths?: string;
  readonly queryParams?: readonly string[];
}

type PolicySettings = { sdx?: { navigate?: { documentOnly?: DocumentOnlyPolicy } } };

export function isDocumentOnlyUrl(href: string, base: string, policy?: DocumentOnlyPolicy): boolean {
  if (!policy) return false;
  try {
    const url = new URL(href, base);
    const params = new Set((policy.queryParams ?? []).map((key) => key.toLowerCase()));
    for (const key of url.searchParams.keys()) {
      if (params.has(key.toLowerCase().split('[')[0])) return true;
    }
    if (!policy.paths) return false;
    let path = url.pathname;
    for (let pass = 0; pass < 3; pass++) {
      const decoded = decodeURIComponent(path);
      if (decoded === path) break;
      path = decoded;
    }
    return new RegExp(policy.paths).test(path.split('\\').join('/'));
  }
  catch {
    // A malformed configured policy or path must not weaken the boundary.
    return true;
  }
}

export function requiresDocumentNavigation(href: string): boolean {
  const settings = (globalThis as unknown as { drupalSettings?: PolicySettings }).drupalSettings;
  const policy = settings?.sdx?.navigate?.documentOnly;
  return isDocumentOnlyUrl(href, location.href, policy)
    || isDocumentOnlyUrl(location.href, location.href, policy);
}
